import { useMutation } from '@vue/apollo-composable';
import { ref } from 'vue';
import {
  updatePlaylistShareLinkAccess,
  deactivatePlaylistShareLink,
  activatePlaylistShareLink,
} from '@/graphql/mutations';
import useGetPlaylistLight from '@/composables/useGetPlaylistLight';

interface UpdatePlaylistPermissionsInput {
  playlistId: string;
  access: string;
  resetShareLink: boolean;
}

export default function useUpdatePlaylistPermissions() {
  const { mutate: updateAccess } = useMutation(updatePlaylistShareLinkAccess);
  const { mutate: deactivateLink } = useMutation(deactivatePlaylistShareLink);
  const { mutate: activateLink } = useMutation(activatePlaylistShareLink);
  const { requestPlaylistLight, queryState } = useGetPlaylistLight();

  const mutation = ref({
    state: 'idle' as 'idle' | 'loading' | 'error',
    name: '',
  });

  const updatePlaylistPermissions = async (
    input: UpdatePlaylistPermissionsInput,
  ) => {
    if (input.resetShareLink) {
      try {
        mutation.value.state = 'loading';
        mutation.value.name = 'resetLink';
        await deactivateLink({
          playlistId: input.playlistId,
        });
        await activateLink({
          playlistId: input.playlistId,
        });
        await requestPlaylistLight(input.playlistId);
        if (queryState.value === 'success') {
          mutation.value.state = 'idle';
          mutation.value.name = 'resetLink';
        }
        return;
      } catch (error) {
        mutation.value.state = 'error';
        setTimeout(() => {
          mutation.value.state = 'idle';
        }, 1500);
        mutation.value.name = 'resetLink';
        console.error('Failed', error);
        return;
      }
    }

    try {
      mutation.value.state = 'loading';
      mutation.value.name = 'toggleAccess';
      await updateAccess({
        playlistId: input.playlistId,
        access: input.access,
      });
      mutation.value.state = 'idle';
      mutation.value.name = 'toggleAccess';
      return;
    } catch (error) {
      mutation.value.state = 'error';
      setTimeout(() => {
        mutation.value.state = 'idle';
      }, 1500);
      mutation.value.name = 'toggleAccess';
      console.error('Failed', error);
    }
  };

  return {
    updatePlaylistPermissions,
    mutation,
  };
}
